import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import signup from './views/sign-up'
import Login from './views/Login'
import forget from './views/forger-password'
import Build from './views/Build.vue'
import AI from './views/AI.vue'
import nlp from './views/nlp'
import nlpAppMain from './components/nlp/sections/main'
import nlpAppIntents from './components/nlp/sections/intents/index.vue'
import nlpAppIntentsSingle from './components/nlp/sections/intents/single.vue'
import nlpAppEntities from './components/nlp/sections/entities/index.vue'
import nlpAppEntitySingle from './components/nlp/sections/entities/single.vue'
import nlpAppVersions from './components/nlp/sections/versions'
import nlpAppUnknownWords from './components/nlp/sections/unknownwords'
import AppKeys from './components/nlp/sections/AppKeys'
import oldNlp from './components/nlp/OldView'
import Bots from './views/Bots'
import settings from './views/settings'
import publish from './views/publish'
import users from './views/users'
import analytics from "./views/analytics";

import botAnalytics from "./components/botAnalytics";
import customAnalytics from "./views/customAnalytics";

import filters from "./views/filters";
import page404 from "./views/404"
import channelConfiguration from "./components/settings/general-setings/chnnaelConfiguration/channelCofiiguration";
import forms from "./components/settings/widger-configuration/forms/forms";
import menus from "./components/settings/widger-configuration/menus/menus";
import faqs from "./components/settings/widger-configuration/faqs/faqs";
import introButtons from "./components/settings/widger-configuration/introButtons/introButtons"
import ConfigureNotifications from "./components/settings/configureNotifications/ListAppNotifications";
import ChatHistory from "./views/ChatHistory"
import broadcasts from "./views/broadcasts"
import BroadcastSingle from "./views/BroadcastSingle"
import badWords from "./components/settings/general-setings/badWords";
import googleReview from "./components/settings/general-setings/googleReviews/googleReview";
import facebookPages from "./components/settings/general-setings/facebookPages/facebookPages";
import SettingsVersions from "./components/settings/versions";
import intentReportTool from "./components/nlp/reportTool/intentReportTool";



import chatHistoryNew from './views/chat-histroy-new'

// campaign manager
import CampaignsMain from './components/campaign-manager/sections/main.vue'
import CampaignsOverview from './components/campaign-manager/sections/overview.vue'
import CampaignsCrud from './components/campaign-manager/campaigns-crud/index.vue'
import CampaignsCrudSingle from './components/campaign-manager/campaigns-crud/single.vue'
import TemplateMessagesCrud from './components/campaign-manager/template-messages-crud/index.vue'
import TemplateMessageEditor from './components/campaign-manager/template-message-editor/index.vue'
import campaignOverview from "./components/campaign-manager/campaign-overview/campaignOverview";
import WhatsappApps from "./components/campaign-manager/smooch-apps/index.vue";

import twitter from "./components/settings/general-setings/twitter/twitter";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { layout: 'auth'}
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: signup,
      meta: { layout: 'auth'}
    },
    {
      path: '/forget-password',
      name: 'forget',
      component: forget,
      meta: { layout: 'no-sidebar'}
    },
    {
      path: '/build',
      name: 'build',
      component: Build,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/ai',
      name: 'ai',
      component: AI,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/nlp-legacy',
      name: 'oldnlp',
      component: oldNlp,
      meta: { layout: 'default', permission: [1]},
    },
    {
      path: '/nlp',
      name: 'nlp',
      component: nlp,
      meta: { layout: 'default', permission: [1]},
    },
    {
          path: '/nlp/unknown-terms',
          component: nlpAppUnknownWords,
          name: 'nlpUnknownWords',
          meta: { layout: 'default', permission: [1], title: 'Unknown Terms'},
     },
    {
      path: '/nlp/intents-report-tool',
      component: intentReportTool,
      name: 'intentReportTool',
      meta: { layout: 'default', permission: [1], title: 'Unknown Terms'},
    },
    {
      path: '/nlp/app/:id',
      name: 'nlpApp',
      component: nlpAppMain,
      meta: { layout: 'default', permission: [1], title: 'App'},
      children: [
        {
          path: '/nlp/app/:id/intents',
          component: nlpAppIntents,
          name: 'nlpIntents',
          meta: { layout: 'default', permission: [1], title: 'Intents'},
        },
        {
          path: '/nlp/app/:id/intents/:intent',
          component: nlpAppIntentsSingle,
          name: 'nlpAppIntentsSingle',
          meta: { layout: 'default', permission: [1], title: 'Intent'},
        },
        {
          path: '/nlp/app/:id/entities',
          component: nlpAppEntities,
          name: 'nlpEntities',
          meta: { layout: 'default', permission: [1], title: 'Entities'},
        },
        {
          path: '/nlp/app/:id/entities/:entity',
          component: nlpAppEntitySingle,
          name: 'nlpAppEntitySingle',
          meta: { layout: 'default', permission: [1], title: 'Entity'},
        },
        {
          path: '/nlp/app/:id/versions',
          component: nlpAppVersions,
          name: 'nlpVersions',
          meta: { layout: 'default', permission: [1], title: 'Versions'},
        },
        {
          path: '/nlp/app/:id/keys',
          component: AppKeys,
          name: 'nlpAppKeys',
          meta: { layout: 'default', permission: [1], title: 'Configure Keys'},
        },
      ]
    },
    {
      path: '/settings',
      name: 'settings',
      component: settings,
      meta: { layout: 'default', permission: [1]},
      children: [
        {
          path: '/settings/channel-configuration',
          component: channelConfiguration,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/google-reviews',
          component: googleReview,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/facebook-pages',
          component: facebookPages,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/twitter',
          component: twitter,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/bad-words',
          component: badWords,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/forms',
          component: forms,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/menus',
          component: menus,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/faqs',
          component: faqs,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/intro-buttons',
          component: introButtons,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/notifications',
          component: ConfigureNotifications,
          meta: { layout: 'default', permission: [1]},
        },
        {
          path: '/settings/versions',
          component: SettingsVersions,
          meta: { layout: 'default', permission: [1]},
        }
      ]
    },
    {
      path: '/campaigns/',
      name: 'allCampaigns',
      component: CampaignsMain,
      meta: { layout: 'default', permission: [1], title: 'Campaign Manager'},
      children: [
        {
          path: '/campaigns/all',
          component: CampaignsCrud,
          name: 'CampaignsCrud',
          meta: { layout: 'default', permission: [1], title: 'Campaings'},
        },
        {
          path: '/campaigns/overview',
          component: CampaignsOverview,
          name: 'CampaignsOverview',
          meta: { layout: 'default', permission: [1], title: 'Campaings'},
        },
        {
          path: '/campaigns/:id/editor',
          component: CampaignsCrudSingle,
          name: 'CampaignsCrudSingle',
          meta: { layout: 'default', permission: [1], title: 'Campaings'},
        },
        {
          path: '/campaigns/:id/overview',
          component: campaignOverview,
          name: 'campaignOverview',
          meta: { layout: 'default', permission: [1], title: 'Campaings'},
        },
        {
          path: '/campaigns/template-messages',
          component: TemplateMessagesCrud,
          name: 'TemplateMessagesCrud',
          meta: { layout: 'default', permission: [1], title: 'Template Messages'},
        },
        {
          path: '/campaigns/template-messages/:id/editor',
          component: TemplateMessageEditor,
          name: 'TemplateMessageEditor',
          meta: { layout: 'default', permission: [1], title: 'Template Message Editor'},
        },
        {
          path: '/campaigns/whatsapp-apps',
          component: WhatsappApps,
          name: 'WhatsappApps',
          meta: { layout: 'default', permission: [1], title: 'Whatsapp Apps'},
        },
      ]
     },
    {
      path: '/publish',
      name: 'publish',
      component: publish,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/',
      name: 'bots',
      component: Bots,
      meta: { layout: 'default', permission: [1,2,3]}
    },
    {
      path: '/users',
      name: 'users',
      component: users,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/insights',
      name: 'analytics',
      component: botAnalytics,
      meta: { layout: 'default', permission: [1,3]}
    },
    {
      path: '/insights-legacy',
      name: 'botanalytics',
      component: analytics,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/filters',
      name: 'filters',
      component: filters,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/chat-history',
      name: 'ChatHistory',
      component: ChatHistory,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/chat-history-new',
      name: 'ChatHistoryNew',
      component: chatHistoryNew,
      meta: { layout: 'default', permission: [1,2]}
    },
    {
      path: '/broadcasts',
      name: 'Broadcasts',
      component: broadcasts,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/broadcasts/:id',
      name: 'BroadcastSingle',
      component: BroadcastSingle,
      meta: { layout: 'default', permission: [1]}
    },
    {
      path: '/404',
      name: '404',
      component: page404,
      meta: { layout: 'default', permission: [1,2,3]}
    },
    {
      path: '/custom-insights',
      name: 'customInsights',
      component: customAnalytics,
      meta: { layout: 'default', permission: [1]}
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  if (!store.state.user.userToken && to.path !== '/login' && to.path !== '/forget-password/' && to.path !== '/sign-up') {
    return next('/login');
  }
  if (store.state.user.userToken && (to.path === '/login' || (!store.state.bot.botId && to.path !== '/'))) {
    return next('/');
  }
  

  if (to.meta.permission && !to.meta.permission.includes(store.state.user.roleId)) {
    if(store.state.user.roleId == 2){
      return next('/chat-history-new')
    }
    return next('/insights')
  }

  if (from.path === '/publish') {
    window.location.href = to.path
  }


  store.dispatch('setCurrentRoute', to.path)
  localStorage.setItem('currentRoute', to.path)
  next();
})


export default router
